/**
 * All UI translations for FastAudio — 10 languages.
 * Keys are shared across all pages/components.
 */
const T = {
  en: {
    // Nav
    home: 'Home', faqs: 'FAQs',
    youtubeDownloader: 'YouTube Downloader',
    instagramDownloader: 'Instagram Downloader',
    tiktokDownloader: 'TikTok Downloader',
    facebookDownloader: 'Facebook Downloader',
    language: 'Language',
    // Home
    homeBadge: 'The fastest converter online',
    homeH1: 'Convert Media Files to',
    homeH2: 'High Quality Audio & HD Video',
    homeSub: 'Paste any YouTube, TikTok, Instagram or Facebook URL to get MP3 audio (up to 320kbps) or MP4 video. No registration, completely free.',
    // YouTube
    youtubeBadge: 'YouTube Downloader',
    youtubeH1: 'YouTube to', youtubeH2: 'MP3 & MP4',
    youtubeSub: 'Download any YouTube video as high-quality MP3 audio or MP4 video. Up to 320kbps audio, up to 1080p video. Free, no registration.',
    // Instagram
    instagramBadge: 'Instagram Downloader',
    instagramH1: 'Instagram to', instagramH2: 'MP3 & MP4',
    instagramSub: 'Download Instagram Reels, posts and IGTV videos as MP3 audio or MP4 video. Free, instant, no account needed.',
    // TikTok
    tiktokBadge: 'TikTok Downloader',
    tiktokH1: 'TikTok to', tiktokH2: 'MP3 & MP4',
    tiktokSub: 'Download TikTok videos as MP3 audio or MP4 video. No watermark, no ads, completely free.',
    // Facebook
    facebookBadge: 'Facebook Downloader',
    facebookH1: 'Facebook to', facebookH2: 'MP3 & MP4',
    facebookSub: 'Download Facebook videos and Reels as MP3 audio or MP4 video. SD and HD quality, no account required, completely free.',
    // Placeholders
    ytPlaceholder: 'Paste a YouTube video URL…',
    igPlaceholder: 'Paste an Instagram post or Reel URL…',
    ttPlaceholder: 'Paste a TikTok video URL…',
    fbPlaceholder: 'Paste a Facebook video URL…',
    genericPlaceholder: 'Paste a YouTube, TikTok, Instagram or Facebook URL…',
    // ConverterBox
    paste: 'Paste', new: 'New', convert: 'Convert',
    quality: 'Quality', fileSize: 'File size', download: 'Download',
    converting: 'Converting…', save: 'Save',
    tryAnotherUrl: 'Try another URL',
    convertAnotherUrl: 'Convert Another URL',
    invalidUrl: 'Please enter a valid URL.',
    couldNotFetch: 'Could not fetch media info.',
    duration: 'Duration', audio: 'Audio', video: 'Video',
    // Feature cards
    fc1Title: 'Instant Conversions',
    fc1Desc: 'Our powerful cloud servers process media files in seconds, not minutes.',
    fc2Title: 'High Quality Audio Video',
    fc2Desc: 'Choose between 128kbps, 192kbps, or pristine 320kbps and a HD Video.',
    fc3Title: 'Safe & Secure',
    fc3Desc: 'No annoying popups, no required software. Completely safe to use.',
    // Disclaimer
    important: 'Important',
    disclaimer: 'This tool is for personal use only. Users must ensure they have rights to download content.',
  },

  es: {
    home: 'Inicio', faqs: 'Preguntas',
    youtubeDownloader: 'Descargar YouTube',
    instagramDownloader: 'Descargar Instagram',
    tiktokDownloader: 'Descargar TikTok',
    facebookDownloader: 'Descargar Facebook',
    language: 'Idioma',
    homeBadge: 'El convertidor más rápido',
    homeH1: 'Convierte archivos a',
    homeH2: 'Audio HD y Video HD',
    homeSub: 'Pega cualquier URL de YouTube, TikTok, Instagram o Facebook para obtener MP3 (hasta 320kbps) o video MP4. Sin registro, completamente gratis.',
    youtubeBadge: 'Descargador de YouTube',
    youtubeH1: 'YouTube a', youtubeH2: 'MP3 y MP4',
    youtubeSub: 'Descarga cualquier video de YouTube como audio MP3 o video MP4. Hasta 320kbps de audio, hasta 1080p de video. Gratis, sin registro.',
    instagramBadge: 'Descargador de Instagram',
    instagramH1: 'Instagram a', instagramH2: 'MP3 y MP4',
    instagramSub: 'Descarga Reels, publicaciones y videos IGTV de Instagram como MP3 o MP4. Gratis, instantáneo.',
    tiktokBadge: 'Descargador de TikTok',
    tiktokH1: 'TikTok a', tiktokH2: 'MP3 y MP4',
    tiktokSub: 'Descarga videos de TikTok como MP3 o MP4. Sin marca de agua, sin anuncios, completamente gratis.',
    facebookBadge: 'Descargador de Facebook',
    facebookH1: 'Facebook a', facebookH2: 'MP3 y MP4',
    facebookSub: 'Descarga videos y Reels de Facebook como MP3 o MP4. Calidad SD y HD, sin cuenta requerida.',
    ytPlaceholder: 'Pega una URL de YouTube…',
    igPlaceholder: 'Pega una URL de Instagram…',
    ttPlaceholder: 'Pega una URL de TikTok…',
    fbPlaceholder: 'Pega una URL de Facebook…',
    genericPlaceholder: 'Pega una URL de YouTube, TikTok, Instagram o Facebook…',
    paste: 'Pegar', new: 'Nuevo',
    quality: 'Calidad', fileSize: 'Tamaño', download: 'Descargar',
    converting: 'Convirtiendo…', save: 'Guardar',
    tryAnotherUrl: 'Intentar otra URL',
    convertAnotherUrl: 'Convertir otra URL',
    invalidUrl: 'Por favor, ingresa una URL válida.',
    couldNotFetch: 'No se pudo obtener información del medio.',
    duration: 'Duración', audio: 'Audio', video: 'Video',
    fc1Title: 'Conversiones instantáneas',
    fc1Desc: 'Nuestros servidores en la nube procesan archivos multimedia en segundos.',
    fc2Title: 'Audio de alta calidad',
    fc2Desc: 'Elige entre 128kbps, 192kbps o la pristina calidad de 320kbps.',
    fc3Title: 'Seguro y protegido',
    fc3Desc: 'Sin ventanas emergentes, sin software requerido. Completamente seguro.',
    important: 'Importante',
    disclaimer: 'Esta herramienta es solo para uso personal. Los usuarios deben asegurarse de tener derechos para descargar contenido.',
  },

  fr: {
    home: 'Accueil', faqs: 'FAQ',
    youtubeDownloader: 'Télécharger YouTube',
    instagramDownloader: 'Télécharger Instagram',
    tiktokDownloader: 'Télécharger TikTok',
    facebookDownloader: 'Télécharger Facebook',
    language: 'Langue',
    homeBadge: 'Le convertisseur le plus rapide',
    homeH1: 'Convertir des fichiers en',
    homeH2: 'Audio & Vidéo HD',
    homeSub: 'Collez une URL YouTube, TikTok, Instagram ou Facebook pour obtenir MP3 (jusqu\'à 320kbps) ou vidéo MP4. Sans inscription, gratuit.',
    youtubeBadge: 'Téléchargeur YouTube',
    youtubeH1: 'YouTube en', youtubeH2: 'MP3 & MP4',
    youtubeSub: 'Téléchargez n\'importe quelle vidéo YouTube en MP3 ou MP4. Jusqu\'à 320kbps audio, jusqu\'à 1080p vidéo. Gratuit.',
    instagramBadge: 'Téléchargeur Instagram',
    instagramH1: 'Instagram en', instagramH2: 'MP3 & MP4',
    instagramSub: 'Téléchargez des Reels et vidéos Instagram en MP3 ou MP4. Gratuit, instantané.',
    tiktokBadge: 'Téléchargeur TikTok',
    tiktokH1: 'TikTok en', tiktokH2: 'MP3 & MP4',
    tiktokSub: 'Téléchargez des vidéos TikTok en MP3 ou MP4. Sans filigrane, sans publicité, gratuit.',
    facebookBadge: 'Téléchargeur Facebook',
    facebookH1: 'Facebook en', facebookH2: 'MP3 & MP4',
    facebookSub: 'Téléchargez des vidéos Facebook en MP3 ou MP4. Qualité SD et HD, sans compte requis.',
    ytPlaceholder: 'Collez une URL YouTube…',
    igPlaceholder: 'Collez une URL Instagram…',
    ttPlaceholder: 'Collez une URL TikTok…',
    fbPlaceholder: 'Collez une URL Facebook…',
    genericPlaceholder: 'Collez une URL YouTube, TikTok, Instagram ou Facebook…',
    paste: 'Coller', new: 'Nouveau',
    quality: 'Qualité', fileSize: 'Taille', download: 'Télécharger',
    converting: 'Conversion…', save: 'Enregistrer',
    tryAnotherUrl: 'Essayer une autre URL',
    convertAnotherUrl: 'Convertir une autre URL',
    invalidUrl: 'Veuillez entrer une URL valide.',
    couldNotFetch: 'Impossible de récupérer les informations du média.',
    duration: 'Durée', audio: 'Audio', video: 'Vidéo',
    fc1Title: 'Conversions instantanées',
    fc1Desc: 'Nos serveurs cloud traitent les fichiers multimédias en quelques secondes.',
    fc2Title: 'Audio haute qualité',
    fc2Desc: 'Choisissez entre 128kbps, 192kbps ou une qualité audio parfaite de 320kbps.',
    fc3Title: 'Sûr et sécurisé',
    fc3Desc: 'Pas de popups, pas de logiciel requis. Complètement sûr.',
    important: 'Important',
    disclaimer: 'Cet outil est uniquement à des fins personnelles. Les utilisateurs doivent s\'assurer d\'avoir les droits pour télécharger le contenu.',
  },

  de: {
    home: 'Startseite', faqs: 'FAQ',
    youtubeDownloader: 'YouTube herunterladen',
    instagramDownloader: 'Instagram herunterladen',
    tiktokDownloader: 'TikTok herunterladen',
    facebookDownloader: 'Facebook herunterladen',
    language: 'Sprache',
    homeBadge: 'Der schnellste Konverter',
    homeH1: 'Mediendateien konvertieren zu',
    homeH2: 'Hochwertigem Audio & HD-Video',
    homeSub: 'URL von YouTube, TikTok, Instagram oder Facebook einfügen für MP3 (bis 320kbps) oder MP4-Video. Ohne Registrierung, völlig kostenlos.',
    youtubeBadge: 'YouTube Downloader',
    youtubeH1: 'YouTube zu', youtubeH2: 'MP3 & MP4',
    youtubeSub: 'Laden Sie beliebige YouTube-Videos als MP3 oder MP4 herunter. Bis zu 320kbps Audio, bis zu 1080p Video. Kostenlos.',
    instagramBadge: 'Instagram Downloader',
    instagramH1: 'Instagram zu', instagramH2: 'MP3 & MP4',
    instagramSub: 'Laden Sie Instagram Reels und Videos als MP3 oder MP4 herunter. Kostenlos, sofort, kein Konto erforderlich.',
    tiktokBadge: 'TikTok Downloader',
    tiktokH1: 'TikTok zu', tiktokH2: 'MP3 & MP4',
    tiktokSub: 'Laden Sie TikTok-Videos als MP3 oder MP4 herunter. Kein Wasserzeichen, keine Werbung, komplett kostenlos.',
    facebookBadge: 'Facebook Downloader',
    facebookH1: 'Facebook zu', facebookH2: 'MP3 & MP4',
    facebookSub: 'Laden Sie Facebook-Videos als MP3 oder MP4 herunter. SD- und HD-Qualität, kein Konto erforderlich.',
    ytPlaceholder: 'YouTube-URL einfügen…',
    igPlaceholder: 'Instagram-URL einfügen…',
    ttPlaceholder: 'TikTok-URL einfügen…',
    fbPlaceholder: 'Facebook-URL einfügen…',
    genericPlaceholder: 'YouTube, TikTok, Instagram oder Facebook URL einfügen…',
    paste: 'Einfügen', new: 'Neu',
    quality: 'Qualität', fileSize: 'Dateigröße', download: 'Herunterladen',
    converting: 'Konvertiere…', save: 'Speichern',
    tryAnotherUrl: 'Andere URL versuchen',
    convertAnotherUrl: 'Weitere URL konvertieren',
    invalidUrl: 'Bitte geben Sie eine gültige URL ein.',
    couldNotFetch: 'Medieninformationen konnten nicht abgerufen werden.',
    duration: 'Dauer', audio: 'Audio', video: 'Video',
    fc1Title: 'Sofortige Konvertierungen',
    fc1Desc: 'Unsere Cloud-Server verarbeiten Mediendateien in Sekunden.',
    fc2Title: 'Hochwertiges Audio',
    fc2Desc: 'Wählen Sie zwischen 128kbps, 192kbps oder makelloser 320kbps Audioqualität.',
    fc3Title: 'Sicher & geschützt',
    fc3Desc: 'Keine lästigen Popups, keine Software erforderlich. Völlig sicher.',
    important: 'Wichtig',
    disclaimer: 'Dieses Tool ist nur für den persönlichen Gebrauch bestimmt. Benutzer müssen sicherstellen, dass sie die Rechte zum Herunterladen haben.',
  },

  pt: {
    home: 'Início', faqs: 'Perguntas',
    youtubeDownloader: 'Baixar YouTube',
    instagramDownloader: 'Baixar Instagram',
    tiktokDownloader: 'Baixar TikTok',
    facebookDownloader: 'Baixar Facebook',
    language: 'Idioma',
    homeBadge: 'O conversor mais rápido',
    homeH1: 'Converter Arquivos em',
    homeH2: 'Áudio & Vídeo HD',
    homeSub: 'Cole qualquer URL do YouTube, TikTok, Instagram ou Facebook para obter MP3 (até 320kbps) ou vídeo MP4. Sem registro, completamente grátis.',
    youtubeBadge: 'Downloader do YouTube',
    youtubeH1: 'YouTube para', youtubeH2: 'MP3 e MP4',
    youtubeSub: 'Baixe qualquer vídeo do YouTube como áudio MP3 ou vídeo MP4. Até 320kbps de áudio, até 1080p de vídeo. Grátis.',
    instagramBadge: 'Downloader do Instagram',
    instagramH1: 'Instagram para', instagramH2: 'MP3 e MP4',
    instagramSub: 'Baixe Reels e vídeos do Instagram como MP3 ou MP4. Grátis, instantâneo, sem conta.',
    tiktokBadge: 'Downloader do TikTok',
    tiktokH1: 'TikTok para', tiktokH2: 'MP3 e MP4',
    tiktokSub: 'Baixe vídeos do TikTok como MP3 ou MP4. Sem marca d\'água, sem anúncios, completamente grátis.',
    facebookBadge: 'Downloader do Facebook',
    facebookH1: 'Facebook para', facebookH2: 'MP3 e MP4',
    facebookSub: 'Baixe vídeos do Facebook como MP3 ou MP4. Qualidade SD e HD, sem conta.',
    ytPlaceholder: 'Cole uma URL do YouTube…',
    igPlaceholder: 'Cole uma URL do Instagram…',
    ttPlaceholder: 'Cole uma URL do TikTok…',
    fbPlaceholder: 'Cole uma URL do Facebook…',
    genericPlaceholder: 'Cole uma URL do YouTube, TikTok, Instagram ou Facebook…',
    paste: 'Colar', new: 'Novo',
    quality: 'Qualidade', fileSize: 'Tamanho', download: 'Baixar',
    converting: 'Convertendo…', save: 'Salvar',
    tryAnotherUrl: 'Tentar outra URL',
    convertAnotherUrl: 'Converter outra URL',
    invalidUrl: 'Por favor, insira uma URL válida.',
    couldNotFetch: 'Não foi possível buscar informações da mídia.',
    duration: 'Duração', audio: 'Áudio', video: 'Vídeo',
    fc1Title: 'Conversões instantâneas',
    fc1Desc: 'Nossos poderosos servidores em nuvem processam arquivos de mídia em segundos.',
    fc2Title: 'Áudio de alta qualidade',
    fc2Desc: 'Escolha entre 128kbps, 192kbps ou qualidade de áudio pristina de 320kbps.',
    fc3Title: 'Seguro e protegido',
    fc3Desc: 'Sem popups irritantes, sem software necessário. Completamente seguro.',
    important: 'Importante',
    disclaimer: 'Esta ferramenta é apenas para uso pessoal. Os usuários devem garantir que têm direitos para baixar o conteúdo.',
  },

  it: {
    home: 'Home', faqs: 'FAQ',
    youtubeDownloader: 'Scarica YouTube',
    instagramDownloader: 'Scarica Instagram',
    tiktokDownloader: 'Scarica TikTok',
    facebookDownloader: 'Scarica Facebook',
    language: 'Lingua',
    homeBadge: 'Il convertitore più veloce',
    homeH1: 'Converti file multimediali in',
    homeH2: 'Audio & Video HD',
    homeSub: 'Incolla qualsiasi URL di YouTube, TikTok, Instagram o Facebook per ottenere MP3 (fino a 320kbps) o video MP4. Senza registrazione, gratis.',
    youtubeBadge: 'Downloader YouTube',
    youtubeH1: 'YouTube in', youtubeH2: 'MP3 e MP4',
    youtubeSub: 'Scarica qualsiasi video YouTube come audio MP3 o video MP4. Fino a 320kbps audio, fino a 1080p video. Gratis.',
    instagramBadge: 'Downloader Instagram',
    instagramH1: 'Instagram in', instagramH2: 'MP3 e MP4',
    instagramSub: 'Scarica Reel e video Instagram come MP3 o MP4. Gratis, istantaneo, nessun account.',
    tiktokBadge: 'Downloader TikTok',
    tiktokH1: 'TikTok in', tiktokH2: 'MP3 e MP4',
    tiktokSub: 'Scarica video TikTok come MP3 o MP4. Senza filigrana, senza pubblicità, completamente gratis.',
    facebookBadge: 'Downloader Facebook',
    facebookH1: 'Facebook in', facebookH2: 'MP3 e MP4',
    facebookSub: 'Scarica video Facebook come MP3 o MP4. Qualità SD e HD, nessun account richiesto.',
    ytPlaceholder: 'Incolla un URL YouTube…',
    igPlaceholder: 'Incolla un URL Instagram…',
    ttPlaceholder: 'Incolla un URL TikTok…',
    fbPlaceholder: 'Incolla un URL Facebook…',
    genericPlaceholder: 'Incolla un URL YouTube, TikTok, Instagram o Facebook…',
    paste: 'Incolla', new: 'Nuovo',
    quality: 'Qualità', fileSize: 'Dimensione', download: 'Scarica',
    converting: 'Conversione…', save: 'Salva',
    tryAnotherUrl: 'Prova un altro URL',
    convertAnotherUrl: 'Converti un altro URL',
    invalidUrl: 'Inserisci un URL valido.',
    couldNotFetch: 'Impossibile recuperare le informazioni multimediali.',
    duration: 'Durata', audio: 'Audio', video: 'Video',
    fc1Title: 'Conversioni istantanee',
    fc1Desc: 'I nostri potenti server cloud elaborano i file multimediali in secondi.',
    fc2Title: 'Audio di alta qualità',
    fc2Desc: 'Scegli tra 128kbps, 192kbps o qualità audio pristina di 320kbps.',
    fc3Title: 'Sicuro e protetto',
    fc3Desc: 'Nessun popup fastidioso, nessun software richiesto. Completamente sicuro.',
    important: 'Importante',
    disclaimer: 'Questo strumento è solo per uso personale. Gli utenti devono assicurarsi di avere i diritti per scaricare i contenuti.',
  },

  ru: {
    home: 'Главная', faqs: 'Вопросы',
    youtubeDownloader: 'Скачать YouTube',
    instagramDownloader: 'Скачать Instagram',
    tiktokDownloader: 'Скачать TikTok',
    facebookDownloader: 'Скачать Facebook',
    language: 'Язык',
    homeBadge: 'Самый быстрый конвертер',
    homeH1: 'Конвертировать медиафайлы в',
    homeH2: 'Аудио и HD Видео',
    homeSub: 'Вставьте URL YouTube, TikTok, Instagram или Facebook для получения MP3 (до 320 кбит/с) или MP4. Без регистрации, бесплатно.',
    youtubeBadge: 'Загрузчик YouTube',
    youtubeH1: 'YouTube в', youtubeH2: 'MP3 и MP4',
    youtubeSub: 'Скачивайте видео YouTube в MP3 или MP4. До 320 кбит/с аудио, до 1080p видео. Бесплатно.',
    instagramBadge: 'Загрузчик Instagram',
    instagramH1: 'Instagram в', instagramH2: 'MP3 и MP4',
    instagramSub: 'Скачивайте Reels и видео Instagram в MP3 или MP4. Бесплатно, мгновенно.',
    tiktokBadge: 'Загрузчик TikTok',
    tiktokH1: 'TikTok в', tiktokH2: 'MP3 и MP4',
    tiktokSub: 'Скачивайте видео TikTok в MP3 или MP4. Без водяных знаков, без рекламы, бесплатно.',
    facebookBadge: 'Загрузчик Facebook',
    facebookH1: 'Facebook в', facebookH2: 'MP3 и MP4',
    facebookSub: 'Скачивайте видео Facebook в MP3 или MP4. Качество SD и HD, без аккаунта.',
    ytPlaceholder: 'Вставьте URL YouTube…',
    igPlaceholder: 'Вставьте URL Instagram…',
    ttPlaceholder: 'Вставьте URL TikTok…',
    fbPlaceholder: 'Вставьте URL Facebook…',
    genericPlaceholder: 'Вставьте URL YouTube, TikTok, Instagram или Facebook…',
    paste: 'Вставить', new: 'Новый',
    quality: 'Качество', fileSize: 'Размер', download: 'Скачать',
    converting: 'Конвертирование…', save: 'Сохранить',
    tryAnotherUrl: 'Попробовать другой URL',
    convertAnotherUrl: 'Конвертировать другой URL',
    invalidUrl: 'Введите действительный URL.',
    couldNotFetch: 'Не удалось получить информацию о медиа.',
    duration: 'Длительность', audio: 'Аудио', video: 'Видео',
    fc1Title: 'Мгновенные конвертации',
    fc1Desc: 'Наши мощные облачные серверы обрабатывают медиафайлы за секунды.',
    fc2Title: 'Высококачественное аудио',
    fc2Desc: 'Выбирайте между 128, 192 или безупречным качеством 320 кбит/с.',
    fc3Title: 'Безопасно и надёжно',
    fc3Desc: 'Без всплывающих окон, без ПО. Полностью безопасно.',
    important: 'Важно',
    disclaimer: 'Этот инструмент предназначен только для личного использования. Пользователи должны убедиться, что имеют право на скачивание контента.',
  },

  ar: {
    home: 'الرئيسية', faqs: 'الأسئلة',
    youtubeDownloader: 'تحميل يوتيوب',
    instagramDownloader: 'تحميل إنستجرام',
    tiktokDownloader: 'تحميل تيك توك',
    facebookDownloader: 'تحميل فيسبوك',
    language: 'اللغة',
    homeBadge: 'أسرع محول على الإنترنت',
    homeH1: 'تحويل ملفات الوسائط إلى',
    homeH2: 'صوت عالي الجودة وفيديو HD',
    homeSub: 'الصق رابط YouTube أو TikTok أو Instagram أو Facebook للحصول على MP3 (حتى 320kbps) أو MP4. بدون تسجيل، مجاناً.',
    youtubeBadge: 'محمل يوتيوب',
    youtubeH1: 'يوتيوب إلى', youtubeH2: 'MP3 و MP4',
    youtubeSub: 'حمّل أي فيديو من يوتيوب بصيغة MP3 أو MP4. حتى 320kbps صوت، حتى 1080p فيديو. مجاناً.',
    instagramBadge: 'محمل إنستجرام',
    instagramH1: 'إنستجرام إلى', instagramH2: 'MP3 و MP4',
    instagramSub: 'حمّل ريلز وفيديوهات إنستجرام بصيغة MP3 أو MP4. مجاناً، فورياً.',
    tiktokBadge: 'محمل تيك توك',
    tiktokH1: 'تيك توك إلى', tiktokH2: 'MP3 و MP4',
    tiktokSub: 'حمّل فيديوهات تيك توك بصيغة MP3 أو MP4. بدون علامة مائية، بدون إعلانات، مجاناً.',
    facebookBadge: 'محمل فيسبوك',
    facebookH1: 'فيسبوك إلى', facebookH2: 'MP3 و MP4',
    facebookSub: 'حمّل فيديوهات فيسبوك بصيغة MP3 أو MP4. جودة SD و HD، بدون حساب.',
    ytPlaceholder: 'الصق رابط يوتيوب…',
    igPlaceholder: 'الصق رابط إنستجرام…',
    ttPlaceholder: 'الصق رابط تيك توك…',
    fbPlaceholder: 'الصق رابط فيسبوك…',
    genericPlaceholder: 'الصق رابط يوتيوب أو تيك توك أو إنستجرام أو فيسبوك…',
    paste: 'لصق', new: 'جديد',
    quality: 'الجودة', fileSize: 'الحجم', download: 'تحميل',
    converting: 'جارٍ التحويل…', save: 'حفظ',
    tryAnotherUrl: 'جرب رابطاً آخر',
    convertAnotherUrl: 'تحويل رابط آخر',
    invalidUrl: 'الرجاء إدخال رابط صالح.',
    couldNotFetch: 'تعذر جلب معلومات الوسائط.',
    duration: 'المدة', audio: 'صوت', video: 'فيديو',
    fc1Title: 'تحويلات فورية',
    fc1Desc: 'تعالج خوادمنا السحابية الملفات في ثوانٍ.',
    fc2Title: 'صوت عالي الجودة',
    fc2Desc: 'اختر بين 128kbps أو 192kbps أو جودة 320kbps المثالية.',
    fc3Title: 'آمن وموثوق',
    fc3Desc: 'بدون نوافذ منبثقة، بدون برامج مطلوبة. آمن تماماً.',
    important: 'هام',
    disclaimer: 'هذه الأداة للاستخدام الشخصي فقط. يجب على المستخدمين التأكد من امتلاكهم الحقوق لتحميل المحتوى.',
  },

  zh: {
    home: '首页', faqs: '常见问题',
    youtubeDownloader: 'YouTube下载',
    instagramDownloader: 'Instagram下载',
    tiktokDownloader: 'TikTok下载',
    facebookDownloader: 'Facebook下载',
    language: '语言',
    homeBadge: '最快的在线转换器',
    homeH1: '将媒体文件转换为',
    homeH2: '高质量音频和HD视频',
    homeSub: '粘贴YouTube、TikTok、Instagram或Facebook链接，获取MP3（最高320kbps）或MP4视频。无需注册，完全免费。',
    youtubeBadge: 'YouTube下载器',
    youtubeH1: 'YouTube转', youtubeH2: 'MP3和MP4',
    youtubeSub: '将任何YouTube视频下载为MP3或MP4。音频最高320kbps，视频最高1080p。免费。',
    instagramBadge: 'Instagram下载器',
    instagramH1: 'Instagram转', instagramH2: 'MP3和MP4',
    instagramSub: '将Instagram短视频和帖子下载为MP3或MP4。免费，即时，无需账号。',
    tiktokBadge: 'TikTok下载器',
    tiktokH1: 'TikTok转', tiktokH2: 'MP3和MP4',
    tiktokSub: '将TikTok视频下载为MP3或MP4。无水印，无广告，完全免费。',
    facebookBadge: 'Facebook下载器',
    facebookH1: 'Facebook转', facebookH2: 'MP3和MP4',
    facebookSub: '将Facebook视频下载为MP3或MP4。SD和HD质量，无需账号。',
    ytPlaceholder: '粘贴YouTube链接…',
    igPlaceholder: '粘贴Instagram链接…',
    ttPlaceholder: '粘贴TikTok链接…',
    fbPlaceholder: '粘贴Facebook链接…',
    genericPlaceholder: '粘贴YouTube、TikTok、Instagram或Facebook链接…',
    paste: '粘贴', new: '新建',
    quality: '质量', fileSize: '文件大小', download: '下载',
    converting: '转换中…', save: '保存',
    tryAnotherUrl: '尝试其他链接',
    convertAnotherUrl: '转换其他链接',
    invalidUrl: '请输入有效的链接。',
    couldNotFetch: '无法获取媒体信息。',
    duration: '时长', audio: '音频', video: '视频',
    fc1Title: '即时转换',
    fc1Desc: '我们强大的云服务器在几秒钟内处理媒体文件。',
    fc2Title: '高质量音频',
    fc2Desc: '在128kbps、192kbps或完美的320kbps音质之间选择。',
    fc3Title: '安全可靠',
    fc3Desc: '无烦人弹窗，无需安装软件。完全安全使用。',
    important: '重要',
    disclaimer: '本工具仅供个人使用。用户必须确保拥有下载内容的权利。',
  },

  ja: {
    home: 'ホーム', faqs: 'よくある質問',
    youtubeDownloader: 'YouTubeダウンロード',
    instagramDownloader: 'Instagramダウンロード',
    tiktokDownloader: 'TikTokダウンロード',
    facebookDownloader: 'Facebookダウンロード',
    language: '言語',
    homeBadge: '最速のオンラインコンバーター',
    homeH1: 'メディアファイルを変換',
    homeH2: '高品質オーディオ・HDビデオ',
    homeSub: 'YouTube、TikTok、Instagram、FacebookのURLを貼り付けてMP3（最大320kbps）またはMP4動画を取得。登録不要、完全無料。',
    youtubeBadge: 'YouTubeダウンローダー',
    youtubeH1: 'YouTubeを', youtubeH2: 'MP3・MP4に変換',
    youtubeSub: 'YouTubeの動画をMP3またはMP4でダウンロード。音声最大320kbps、動画最大1080p。無料。',
    instagramBadge: 'Instagramダウンローダー',
    instagramH1: 'Instagramを', instagramH2: 'MP3・MP4に変換',
    instagramSub: 'InstagramのReelsや動画をMP3またはMP4でダウンロード。無料、即時。',
    tiktokBadge: 'TikTokダウンローダー',
    tiktokH1: 'TikTokを', tiktokH2: 'MP3・MP4に変換',
    tiktokSub: 'TikTok動画をMP3またはMP4でダウンロード。透かしなし、広告なし、完全無料。',
    facebookBadge: 'Facebookダウンローダー',
    facebookH1: 'Facebookを', facebookH2: 'MP3・MP4に変換',
    facebookSub: 'Facebook動画をMP3またはMP4でダウンロード。SDおよびHD品質、アカウント不要。',
    ytPlaceholder: 'YouTubeのURLを貼り付け…',
    igPlaceholder: 'InstagramのURLを貼り付け…',
    ttPlaceholder: 'TikTokのURLを貼り付け…',
    fbPlaceholder: 'FacebookのURLを貼り付け…',
    genericPlaceholder: 'YouTube、TikTok、Instagram、FacebookのURLを貼り付け…',
    paste: '貼り付け', new: '新規',
    quality: '品質', fileSize: 'サイズ', download: 'ダウンロード',
    converting: '変換中…', save: '保存',
    tryAnotherUrl: '別のURLを試す',
    convertAnotherUrl: '別のURLを変換',
    invalidUrl: '有効なURLを入力してください。',
    couldNotFetch: 'メディア情報を取得できませんでした。',
    duration: '長さ', audio: 'オーディオ', video: 'ビデオ',
    fc1Title: '即時変換',
    fc1Desc: '強力なクラウドサーバーが数秒でメディアファイルを処理します。',
    fc2Title: '高品質オーディオ',
    fc2Desc: '128kbps、192kbps、または完璧な320kbpsの音質から選択。',
    fc3Title: '安全・確実',
    fc3Desc: '煩わしいポップアップなし、ソフトウェア不要。完全に安全。',
    important: '重要',
    disclaimer: 'このツールは個人使用のみです。ユーザーはコンテンツをダウンロードする権利があることを確認する必要があります。',
  },
}

export default T
